export default {
    setView(state, payload) {
        state.isMurdersView = payload.value;
      },
}